import {
  propertyList,
  categoryList,
  userList,
  productList,
  property,
  category,
  user,
  product,
  homepage,
  abstract,
  abstractList,
  page,
  pageList,
  integration,
  integrationList,
  facility,
  facilitiesList,
  spaTreatment,
  spaTreatmentsList,
  spaClass,
  spaClassList,
  spaClassTimeslot,
  spaClassTimeslotList,
  packaging,
  packagingList,
  postage,
  postageList,
  spaPackagesList,
  spaPackagesAllList,
  spaPackage,
  option,
  optionList,
} from '@store/schemas';

export const entitiesStructureMapList = {
  properties: propertyList,
  categories: categoryList,
  users: userList,
  products: productList,
  abstracts: abstractList,
  pages: pageList,
  integrations: integrationList,
  facilities: facilitiesList,
  spaTreatments: spaTreatmentsList,
  spaPackages: spaPackagesList,
  spaPackagesAll: spaPackagesAllList,
  spaClasses: spaClassList,
  spaClassTimeslot: spaClassTimeslotList,
  packagings: packagingList,
  postages: postageList,
  options: optionList,
};

export const entitiesStructureMap = {
  properties: property,
  categories: category,
  users: user,
  products: product,
  homepages: homepage,
  abstracts: abstract,
  pages: page,
  integrations: integration,
  facilities: facility,
  spaTreatments: spaTreatment,
  spaPackages: spaPackage,
  spaClasses: spaClass,
  spaClassTimeslot,
  packagings: packaging,
  postages: postage,
  options: option,
};

export enum EntityName {
  spaPackages = 'spaPackages',
  spaPackagesAll = 'spaPackagesAll',
}
